import { useMemo } from 'react';

import { useSession } from '@/context/SessionContext';
import { useScope } from '@workspace/scope-context';

export function useTenantUsersAccess() {
  const { session } = useSession();
  const { activeTenant } = useScope();

  return useMemo(() => {
    const tenantId = activeTenant?.id ?? '';
    const tenantPermissions = tenantId ? (session?.permissionSummary?.tenants?.[tenantId] ?? []) : [];
    const globalPermissions = session?.permissionSummary?.global ?? [];
    const canManage =
      !!tenantId &&
      (tenantPermissions.includes('tenant.members.manage') ||
        globalPermissions.includes('tenant.manage') ||
        globalPermissions.includes('platform.manage'));

    return {
      tenantId,
      canManage,
      accessEnabled: canManage,
    };
  }, [activeTenant?.id, session?.permissionSummary?.global, session?.permissionSummary?.tenants]);
}
